import { render } from "./UCDatosComplementarios.vue?vue&type=template&id=d60d7da8"
import script from "./UCDatosComplementarios.vue?vue&type=script&lang=js"
export * from "./UCDatosComplementarios.vue?vue&type=script&lang=js"

import "./UCDatosComplementarios.vue?vue&type=style&index=0&id=d60d7da8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__